<div class="login-page">
  <app-user-login-form
    class="w-full flex items-center justify-center"
  ></app-user-login-form>
  <div class="flex flex-col gap-y-2">
    <div
      class="text-center cursor-pointer"
      [routerLink]="['/', RouteNames.REGISTER_PAGE]"
    >
      {{ 'route.name.registration' | transloco }}
    </div>
    <div
      class="text-center cursor-pointer"
      [routerLink]="['/', RouteNames.RESET_PASSWORD_PAGE]"
    >
      {{ 'auth.forgotPassword' | transloco }}
    </div>
    <div class="flex justify-center">
      <app-sign-in-with-google></app-sign-in-with-google>
    </div>
  </div>
</div>
